import styled from 'styled-components';

export const StyledSettlementsDoneElement = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 13px;
    margin-top: ${({ $isFirstChild }) => ($isFirstChild ? '0' : '15px')};
`;
